import { getObjectUtil } from 'packages/src'
import EXERCISES_PATH from '../../constants/path'

const getTypesFiltersExercisesSelector = state => getObjectUtil(
  state,
  EXERCISES_PATH.TYPE_FILTER
)

export default getTypesFiltersExercisesSelector
